import styled from 'styled-components';
import { cssVars } from '../shared/lib/styledTheme';

export const AppContainer = styled.div`
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  color: ${cssVars.textPrimary};
  background-color: ${cssVars.bgColor};
  min-height: 100vh;
  transition: background-color 0.3s ease, color 0.3s ease;
  display: flex;
  margin-left: ${cssVars.sidebarWidth};
  transition: margin-left 0.3s ease;
`;
